import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Button,
  FormControl,
  FormLabel,
  Textarea,
  Select,
  Box,
  Stack,
  Icon,
  VStack,
  Badge,
  Flex,
  Text,
  Image,
  Collapse,
  SlideFade,
  useColorModeValue,
  useToast,
} from '@chakra-ui/react';
import { FaArrowLeft, FaStar, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import axiosInstance from '../utils/axiosInstance';
import CheckoutForm from './CheckoutForm';
import {jwtDecode} from 'jwt-decode';
import dayjs from 'dayjs';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useLocation } from "react-router-dom";
import { useCart } from '../context/CartContext';


const stripe_key =
  window.location.origin === 'https://www.papirazzi.app'
    ? process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
    : process.env.REACT_APP_STRIPE_TEST_PUBLISHABLE_KEY;
const stripePromise = loadStripe(stripe_key);

const PhotographerDetail = ({ photographer, onClose, goBack }) => {
  const [clientSecret, setClientSecret] = useState("");
  const [description, setDescription] = useState("");
  const [showCheckout, setShowCheckout] = useState(false);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const bgColor = useColorModeValue("white", "black");
  const textColor = useColorModeValue("black", "white");
  const borderColor = useColorModeValue("gray.700", "gray.500");
  const [costOpen, setCostOpen] = useState(false); // ✅ Cost breakdown toggle
  const [viewMode, setViewMode] = useState("form"); // ✅ Controls form & checkout views
  const toast = useToast();
  const location = useLocation();
  const isUserPage = location.pathname.startsWith("/user/");
  


  const { cartItems, setCartItems } = useCart(); // 🔁 global cart state


  const handleAddToCart = () => {
    // ✅ Validate required fields
    if (!description.trim() || !startTime || !endTime) {
      toast({
        title: 'Missing info',
        description: 'Please fill in start time, end time, and a description.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }
  
    // ✅ Check for auth token
    const token = localStorage.getItem('token');
    if (!token) {
      toast({
        title: 'Not logged in',
        description: 'You must be logged in to book a photographer.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }
  
    const decoded = jwtDecode(token);
    if (decoded.user_id === photographer.id) {
      toast({
        title: 'Invalid action',
        description: 'You cannot book yourself.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }
  
    // ✅ Prepare item
    const newItem = {
      id: photographer.id,
      photographer, // TODO: Need to make sure user-type is used. photographer, model, studio
      duration: durationInHours,
      description,
      startTime,
      endTime,
      from_date: dayjs(selectedDate).format('ddd MMM D YYYY')
    };
  
    // ✅ Prevent duplicate entry
    console.log()
    const existingItem = cartItems.find(item => item.id === newItem.id);
  
    if (existingItem) {
      toast({
        title: 'Photographer already in cart.',
        status: 'info',
        duration: 2000,
        isClosable: true,
      });
      return;
    }
  
    // ✅ Add to cart
    const updatedCart = [...cartItems, newItem];
    setCartItems(updatedCart);
  
    toast({
      title: 'Photographer added to cart!',
      status: 'success',
      duration: 2000,
      isClosable: true,
    });
  };


  // Generate available time slots based on photographer's schedule
  const generateTimeSlots = (date, start, end) => {
    const slots = [];
    console.log("Checking", date);
    const now = dayjs(); // Get the current time
    const fromDate = dayjs(`${date} ${start}`, "ddd MMM D YYYY hh:mm A");
    const endDateTime = dayjs(`${date} ${end}`, "ddd MMM D YYYY hh:mm A");
  
    console.log("Current Time:", now.format());
    console.log("Start Time:", fromDate.format());
    console.log("End Time:", endDateTime.format());
  
    // Round current time to the nearest next XX:00 or XX:30
    let currentTime = fromDate.isBefore(now)
      ? now.add(30 - (now.minute() % 30), "minute").startOf("minute")
      : fromDate;
  
    while (currentTime.isBefore(endDateTime)) {
      // Use `h:mm A` for 12-hour format with AM/PM
      slots.push(currentTime.format("h:mm A"));
      currentTime = currentTime.add(30, "minute"); // Increment by 30 minutes
    }
  
    return slots;
  };
  

  // Calculate duration in hours
  const calculateDurationInHours = (date, startTime, endTime) => {
    console.log("DATE",date)
    console.log('START',  startTime)
    const start = dayjs(`${date} ${startTime}`, "ddd MMM D YYYY HH:mm");
    const end = dayjs(`${date} ${endTime}`, "ddd MMM D YYYY HH:mm");
    console.log(start.format())

    // Duration in minutes, converted to hours
    const duration = end.diff(start, 'minute') / 60;
    return Math.max(duration, 0).toFixed(1);  // Round to 1 decimal place
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toDateString(); // Converts to "Fri Mar 21 2025"
  };
  const durationDate = isUserPage ? formatDate(selectedDate) : photographer.from_date;

  const durationInHours = calculateDurationInHours(durationDate, startTime, endTime);
  console.log(`Selected Duration: ${durationInHours} hours`);
  // Generate available time slots for the selected date
  console.log("SELECTED",selectedDate)
  const availableTimeSlots = generateTimeSlots(
    dayjs(selectedDate).format('ddd MMM D YYYY'),
    photographer.start_time,
    photographer.end_time
  );
 
  const totalrate = durationInHours * photographer.price;
  console.log(`Total Cost: $${totalrate.toFixed(2)}`);

  const platform_fee = totalrate > 0 ? ((totalrate + 10) + totalrate * 0.1) - totalrate : 0;
  const stripe_fee = totalrate > 0 ? (totalrate + platform_fee) * 0.029 + 0.3 : 0;

  //const total_fees = (platform_fee + stripe_fee).toFixed(2);
  const finalTotal =  (totalrate + platform_fee + stripe_fee).toFixed(2)


  // Ensure end times are at least 1 hour after the selected start time
  const getValidEndTimes = (selectedStartTime, availableSlots) => {
    const startIndex = availableSlots.findIndex((slot) => slot === selectedStartTime);
    if (startIndex === -1) return [];

    // End times start at least 1 hour (2 slots) after the start time
    return availableSlots.slice(startIndex + 2);
  };

  console.log("Available Time Slots:", availableTimeSlots);

  console.log("AVATAR",photographer.avatar)

  useEffect(() => {
    const createPaymentIntent = async () => {
      try {
        const backendUrl =
          process.env.NODE_ENV === 'production'
            ? process.env.REACT_APP_BACKEND_URL
            : 'http://localhost:8080';

        const response = await axiosInstance.post(
          `${backendUrl}/create-payment-intent`,
          {
            photographerId: photographer.id,
            description: description,
            duration: durationInHours
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );

        setClientSecret(response.data.clientSecret);
      } catch (error) {
        console.error('Error creating PaymentIntent:', error);
      }
    };

    if (showCheckout && description) {
      createPaymentIntent();
    }
  }, [photographer.id, description, showCheckout]);

  const handlePayNow = () => {
    if (description.trim() && startTime && endTime) {
      const token = localStorage.getItem('token');

      if (token) {
        const decoded = jwtDecode(token);

        if (decoded.user_id === photographer.id) {
          toast({
            title: 'Error',
            description: 'You cannot book yourself.',
            status: 'error',
            duration: 5000,
            isClosable: true,
          });
          return;
        } else {
          setShowCheckout(true);
          setViewMode("checkout"); // ✅ Transition to checkout
        }
      }
    } else {
      toast({
        title: 'Error',
        description: 'Please provide all required information, including times.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Modal isOpen={true} onClose={onClose} motionPreset="slideInBottom">
      <ModalOverlay />
      <ModalContent
        position="fixed"
        top="10%"
        transform="translate(-50%, 0)"
        width={{ base: "95%", md: "80%", lg: "60%" }}
        maxW="420px"
        borderRadius="xl"
        overflow="hidden"
        boxShadow="xl"
        p={0}
        bg={bgColor}
      >
        <ModalBody p={4} color={textColor}>
          <Flex justify="space-between" align="center">
            {/* ✅ Back Button: Goes to Preview OR Form */}

            <Icon 
              as={FaArrowLeft} 
              boxSize={5} 
              cursor="pointer" 
              color={textColor} 
              onClick={() => setViewMode(viewMode === "checkout" ? "form" : goBack())}
              />
            <ModalCloseButton position="absolute" right="10px" />
          </Flex>
          {/* Scrollable Section */}
          <Box
            maxHeight="70vh"
            overflowY="auto"
            px={4}
            pb={6}
          >
          {/* ✅ Profile Image + Rating (ONLY in Form View) */}
          {viewMode !== "checkout" && (
            <VStack mt={4} spacing={1} textAlign="center">
              <Image
                src={photographer.avatar || "/placeholder.jpg"}
                alt={photographer.name}
                boxSize="80px"
                borderRadius="full"
                objectFit="cover"
                border="3px solid white"
              />
              <Text fontSize="xl" fontWeight="bold">
                {photographer.first_name} {photographer.last_name}
              </Text>
              <Flex align="center">
                <Icon as={FaStar} color="yellow.400" mr={1} />
                <Text fontSize="sm">{photographer.rating || "No Rating"}</Text>
              </Flex>
              <Badge colorScheme="purple" fontSize="md">
                ${photographer.price}/hr
              </Badge>
            </VStack>
          )}

          {/* ✅ Slide Between Booking Form & Checkout */}
          <SlideFade in={viewMode === "form"} offsetY="20px">
          {viewMode === "form"  && (
            <VStack spacing={4} align="stretch" mt={4}>
              <Box p={4} borderRadius="md" bg={bgColor} borderWidth="1px" >
                <Stack spacing={3}>
                  <FormControl id="shootDate">
                    <FormLabel color={textColor}>Select Date</FormLabel>
                    <DatePicker
                      selected={selectedDate}
                      onChange={(date) => setSelectedDate(date)}
                      minDate={new Date()}
                      placeholderText="Select a date"
                      dateFormat="EEE MMM d yyyy"
                      className="chakra-input"
                    />
                  </FormControl>

                  <Flex>
                    <FormControl id="startTime">
                      <FormLabel color={textColor}>Start Time</FormLabel>
                      <Select
                        placeholder="Start Time"
                        value={startTime}
                        onChange={(e) => {
                          setStartTime(e.target.value);
                          setEndTime(''); // Reset end time whenever a new start time is selected
                        }}
                        borderColor={"gray.400"}
                      >
                        {availableTimeSlots.map((slot) => (
                        <option key={slot} value={slot}>
                          {slot}
                        </option>
                      ))}
                      </Select>
                    </FormControl>

                    <FormControl id="endTime" ml={2}>
                      <FormLabel color={textColor}>End Time</FormLabel>
                      <Select
                        placeholder="End Time"
                        value={endTime}
                        onChange={(e) => setEndTime(e.target.value)}
                        borderColor={"gray.400"}
                      >
                        {getValidEndTimes(startTime, availableTimeSlots).map((slot) => (
                        <option key={slot} value={slot}>
                          {slot}
                        </option>
                      ))}
                      </Select>
                    </FormControl>
                  </Flex>
                  
                  <FormControl id="shootDescription">
                    <FormLabel color={textColor}>Describe Your Shoot</FormLabel>
                    <Textarea borderColor={"gray.400"} value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Describe what you need for this shoot..." rows={3} />
                  </FormControl>

                  {/* ✅ Cost Breakdown (Collapsible) */}
                  <Button onClick={() => setCostOpen(!costOpen)} variant="outline" colorScheme="purple" size="sm">
                    {costOpen ? "Hide Cost Breakdown" : "View Cost Breakdown"} {costOpen ? <FaChevronUp /> : <FaChevronDown />}
                  </Button>

                  <Collapse in={costOpen} animateOpacity>
                    <Box p={3} bg="gray.700" borderRadius="md">
                    <Flex alignItems="center">
                    <Text minWidth="120px">Hourly Rate:</Text>
                    <Text color="green.500" fontWeight="bold">${photographer.price}</Text>
                  </Flex>
                  <Flex alignItems="center">
                    <Text minWidth="120px">Duration:</Text>
                    <Text color="green.500" fontWeight="bold">{durationInHours}/HRS</Text>
                  </Flex>
                  <Flex alignItems="center">
                    <Text minWidth="120px">Platform Fees:</Text>
                    <Text color="green.500" fontWeight="bold">${(platform_fee + stripe_fee).toFixed(2)}</Text>
                  </Flex>
                  <Flex alignItems="center">
                    <Text minWidth="120px">Total:</Text>
                    <Text color="green.500" fontWeight="bold">${(totalrate + platform_fee + stripe_fee).toFixed(2)}</Text>
                  </Flex>
                    </Box>
                  </Collapse>
                </Stack>
              </Box>

              {/* ✅ Add to Cart Button */}
              <Button
                colorScheme="purple"
                w="full"
                size="lg"
                borderRadius="full"
                onClick={handleAddToCart} // 🔥 custom handler
              >
                Add to Cart
              </Button>
            </VStack>
          )}
        </SlideFade>
        {/* ✅ Checkout Screen Slides In */}
        {viewMode === "checkout" && (
            <SlideFade in={viewMode === "checkout"} offsetY="20px">
              {clientSecret && (
                <Elements stripe={stripePromise} options={{ clientSecret }}>
                  <CheckoutForm 
                    photographer={photographer}
                    description={description}
                    fromDate={dayjs(selectedDate).format('ddd MMM D YYYY')}
                    fromTime={startTime}
                    toTime={endTime}
                    duration={durationInHours}
                   />
                </Elements>
              )}
            </SlideFade>
          )}
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PhotographerDetail;